import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { CanDoActionDirective } from '@app/core/directives/can-do-action.directive';
import { UserPermissionCodeEnum } from '@app/core/enums/user-permission-code.enum';
import { AuthFacade } from '@app/core/facades/auth.facade';
import { User } from '@app/core/models/user';
import { Menu } from '@app/shell/models';
import { InitialsPipe } from '@hal/common';
import { TranslateModule } from '@ngx-translate/core';
import { BadgeModule } from '@progress/kendo-angular-indicators';
import { AvatarModule } from '@progress/kendo-angular-layout';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { Subscription } from 'rxjs';

@Component({
  selector: '[app-sidebar]',
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    BadgeModule,
    TranslateModule,
    TooltipModule,
    CanDoActionDirective,
    AvatarModule,
    InitialsPipe,
  ],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnDestroy {
  public user!: User | null;
  public menu: Menu[] = [];
  private _subscription: Subscription = new Subscription();

  constructor(private _authFacade: AuthFacade) {
    this._setMenu();
    this._subscription.add(
      this._authFacade.user$.subscribe((user) => {
        this.user = user;
      })
    );
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }

  public onCloseBtnClick() {
    const sidebar = document.querySelector('.sidebar');

    sidebar?.classList?.toggle('open');
  }

  public logout() {
    this._authFacade.logout();
  }

  private _setMenu() {
    this.menu.push({
      name: 'MODELS.TITLE',
      icon: 'ico-mlmodels',
      url: '/models',
      permissions: [UserPermissionCodeEnum.VIEW_SCENARIO],
    });
    this.menu.push({
      name: 'SCENARIOS.TITLE',
      icon: 'ico-analytics-graph-bar',
      url: '/scenarios',
      permissions: [UserPermissionCodeEnum.VIEW_SCENARIO],
    });
    this.menu.push({
      name: 'RETENTION.TITLE',
      icon: 'ico-chart-areaspline',
      url: '/scenario-result/retention',
      permissions: [UserPermissionCodeEnum.VIEW_SCENARIO],
    });
    this.menu.push({
      name: 'USERS.USERS_LIST',
      icon: 'ico-users',
      url: '/users',
      permissions: [UserPermissionCodeEnum.VIEW_USER],
    });
    this.menu.push({
      name: 'ADMIN.TITLE',
      icon: 'ico-secret',
      url: '/admin',
      permissions: [UserPermissionCodeEnum.VIEW_ADMIN_AREA],
    });
  }
}
